import { z } from "zod"

export const AdminUserSchema = z.object({
  id: z.number(),
  username: z.string(),
  first_name: z.string(),
  last_name: z.string().nullable(),
  full_name: z.string(),
  email: z.string(),
  status: z.number(),
  type: z.number(),
  agency_id: z.number(),
  agency_name: z.string().nullable(),
  avatar: z.string().nullable(),
  two_fa_type: z.string().nullable(),
  failed_2fa_attempts: z.number(),
  last_login_at: z.string().nullable(),
  last_login_ip: z.string().nullable(),
  last_login_user_agent: z.string().nullable(),
  last_login_browser: z.string().nullable().optional(),
  last_login_os: z.string().nullable().optional(),
  last_login_attempt_at: z.string().nullable(),
  daily_newsletter_enabled: z.boolean(),
  agency_visit_newsletter_enabled: z.boolean(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  roles: z.array(z.string()).optional(),
})

export const AdminUserFormSchema = z.object({
  username: z.string().min(2, "adminUsers.validation.usernameRequired"),
  first_name: z.string().min(1, "adminUsers.validation.firstNameRequired"),
  last_name: z.string().min(1, "adminUsers.validation.lastNameRequired"),
  email: z.string().email("adminUsers.validation.emailInvalid"),
  password: z.string().min(6, "adminUsers.validation.passwordMin").optional().default(""),
  agency_id: z.number().positive("adminUsers.validation.agencyRequired"),
  status: z.number().default(10),
  type: z.number().default(1),
  daily_newsletter_enabled: z.boolean().default(true),
  agency_visit_newsletter_enabled: z.boolean().default(false),
})

export const ResetPasswordSchema = z.object({
  password: z.string().min(6, "adminUsers.validation.passwordMin"),
})

export const UserRolesSchema = z.object({
  assigned: z.array(z.string()),
  available: z.array(z.string()),
})

export const STATUS_ACTIVE = 10
export const STATUS_SUSPENDED = 2
export const STATUS_DELETED = 0

export const STATUS_MAP: Record<number, { label: string; color: string; icon: string; description: string }> = {
  [STATUS_ACTIVE]: { label: "active", color: "green", icon: "fa fa-check-circle", description: "accountActive" },
  [STATUS_SUSPENDED]: { label: "suspended", color: "orange", icon: "fa fa-pause-circle", description: "accountSuspended" },
  [STATUS_DELETED]: { label: "inactive", color: "gray", icon: "fa fa-times-circle", description: "accountInactive" },
}

export const TYPE_MAP: Record<number, { label: string; color: string }> = {
  1: { label: "GPA", color: "blue" },
  2: { label: "BEST", color: "violet" },
}

export const MAX_2FA_ATTEMPTS = 3

export type AdminUser = z.infer<typeof AdminUserSchema>
export type AdminUserFormValues = z.infer<typeof AdminUserFormSchema>
export type ResetPasswordFormValues = z.infer<typeof ResetPasswordSchema>
export type UserRoles = z.infer<typeof UserRolesSchema>
